import React, { useState, useEffect, useCallback, useRef } from "react";
import { Helmet } from "react-helmet";

import logo from "../../src/assets/poweredlogo.png";
import cislogo from "../../src/assets/Logo.png";
import participant1 from "../../src/assets/tundegwr.png";
import participant2 from "../../src/assets/opponentgwr.png";
import flag from "../../src/assets/flag.png";

import {
  Calendar,
  ChatIcon,
  Clock,
  Money,
  NewYork,
  Target,
  World,
} from "../assets/svgs/SVGIcons";
import styled from "styled-components";

const API_KEY = process.env.REACT_APP_YOUTUBE_API_KEY || "YOUR_API_KEY_HERE";
const YOUTUBE_VIDEO_ID = "w_-PzPMdGcg";
const API_URL = process.env.REACT_APP_API_URL || "";

const TIMER_START_DATE = new Date(
  Date.UTC(
    2025, // Year
    3, // Month (0-based, so 3 = April)
    17, // Day
    17, //  AM/PM GMT
    2, // Minutes
    0 // Seconds
  )
);

const PARTICIPANTS = [
  {
    id: 1,
    name: "Tunde Onakoya",
    instagram: "@tunde_onakoya",
    link: "https://www.instagram.com/tunde_onakoya?igsh=eXRrdmt3bXAyOGE1",
    image: participant1,
  },
  {
    id: 2,
    name: "Shawn Martinez",
    instagram: "@pushingpawnsnyc",
    link: "https://www.instagram.com/pushingpawnsnyc?igsh=MXQ1eDdoeDZjbHYwbQ==",
    image: participant2,
  },
];

const DONATION_OPTIONS = [
  {
    id: 0,
    title: "Donate via GoFundMe",
    description:
      "Support our rising chess stars as they represent Africa and inspire the world on the global stage",
    link: "https://www.gofundme.com/f/help-5-children-from-chess-in-slums-go-compete-in-harvard/donations?lid=5t67eofkbs7t&utm_medium=email&utm_source=product&utm_campaign=t_email-co_welcome-0221-us",
    icon: "fa-graduation-cap",
  },
  {
    id: 1,
    title: "Donate via Tiltify",
    description:
      "Support Tunde's attempt to break the Guinness World Record for the longest chess marathon",
    link: "https://tiltify.com/@tunde/tunde-onakoya-vs-shawn-martinez-raising-support-to-build-the-biggest-free-school-for-homeless-child",
    icon: "fa-heart",
  },
  {
    id: 2,
    title: "Donate in Naira",
    description:
      "0089938330\nSterling Bank\nChess In Slums Initiative Donation",
    link: "",
    icon: "fa-money-bill-wave",
  },
  {
    id: 3,
    title: "Donate with Cryptocurrency",
    description: "Donate via our crypto wallet addresses",
    link: "",
    icon: "fa-bitcoin",
    isCrypto: true,
  },
  {
    id: 4,
    title: "NeoChess x Tunde Onakoya",
    description: "Donate by purchasing Tunde's special edition chess boards.",
    link: "https://neochess.com/collections/chessinslumsafrica/",
    icon: "fa-chess",
  },
  {
    id: 5,
    title: "Dream Fila",
    description: "Donate by purchasing Tunde's Special Chess Fila",
    link: "https://links.myvendy.com/DreamersFila",
    icon: "fa-tshirt",
  },
];

const BACKSTORY = `
The current world record for the longest chess marathon stands at 61 hours, set by two Norwegian players. We're aiming for 70 hours of nonstop chess to set a new Guinness World Record.

But this is more than just a record-breaking attempt.

It's a mission to raise $1 million to build the largest tuition-free school for vulnerable children — a place where dreams are not limited by circumstance.

Tunde Onakoya won't be doing it alone. For a few powerful hours, he'll be joined by the very children whose stories have inspired this movement — our champions from Chess in Slums Africa, currently on a chess tour in the USA, who've shown the world that greatness can rise from the most unexpected places.

Let's build something extraordinary together.
Donate now and help turn every move into a step toward their future.
`;

const MAX_MESSAGES = 100;

const TundeGWR = () => {
  const [viewers, setViewers] = useState(0);
  const [timer, setTimer] = useState({ hours: 0, minutes: 0, seconds: 0 });
  const [messages, setMessages] = useState([
    {
      id: 1,
      user: "@chessinlumsafrica",
      message: "We appreciate all the love, support and donations. Ubuntu 💜",
    },
  ]);
  const [selectedPlatform, setSelectedPlatform] = useState("twitch");
  const [showStreamOptions, setShowStreamOptions] = useState(false);
  const [liveChatId, setLiveChatId] = useState(null);
  const [nextPageToken, setNextPageToken] = useState(null);
  const [showDonateModal, setShowDonateModal] = useState(false);
  const [showBackstoryModal, setShowBackstoryModal] = useState(false);
  const [hoveredParticipant, setHoveredParticipant] = useState(null);
  const [chatVisible, setChatVisible] = useState(true);
  const [apiErrors, setApiErrors] = useState({
    youtube: false,
    livechat: false,
  });
  const [copiedText, setCopiedText] = useState("");
  const [showMobileChatModal, setShowMobileChatModal] = useState(false);
  const [showCryptoModal, setShowCryptoModal] = useState(false);

  const CRYPTO_WALLETS = [
    {
      name: "Bitcoin (BTC):",
      address: "bc1qhxrtt5jwtxdeazpml24kk225j35sm4chzuxmn5",
    },
    {
      name: "Ethereum (ETH, USDT, USDC):",
      address: "0xE9A3120A4c9D414fDcE60C7755350e17DE6c5A34",
    },
    {
      name: "Solana (SOL, USDT, USDC):",
      address: "B4QahvwVD6uRSJ91uTf6bZNeDc9hdXuPDqmmygPv9xzv",
    },
    {
      name: "Base (ETH, USDC):",
      address: "0xE9A3120A4c9D414fDcE60C7755350e17DE6c5A34",
    },
    {
      name: "BEP20 (BNB, USDT, USDC):",
      address: "0xE9A3120A4c9D414fDcE60C7755350e17DE6c5A34",
    },
    {
      name: "TRC20 (TRX, USDT):",
      address: "TGZJUGD2DHRdAgtG2bVxBzHumY72vAgSVo",
    },
  ];

  const lastCallTimeRef = useRef(0);
  const throttleInterval = 30000;

  // useEffect(() => {
  //   const calculateTimeDifference = () => {
  //     const now = new Date();
  //     const diff = now - TIMER_START_DATE;

  //     if (diff < 0) return { hours: 0, minutes: 0, seconds: 0 };
  //     const totalSeconds = Math.floor(diff / 1000);

  //     const hours = Math.floor(totalSeconds / 3600);
  //     const minutes = Math.floor((totalSeconds % 3600) / 60);
  //     const seconds = totalSeconds % 60;

  //     return { hours, minutes, seconds };
  //   };

  //   setTimer(calculateTimeDifference());
  //   const interval = setInterval(() => {
  //     setTimer(calculateTimeDifference());
  //   }, 1000);

  //   return () => clearInterval(interval);
  // }, []);

  const fetchLiveChatId = useCallback(async () => {
    if (!YOUTUBE_VIDEO_ID || apiErrors.youtube) {
      console.log(
        "Skipping YouTube API call due to missing ID or previous errors"
      );
      return;
    }

    try {
      const response = await fetch(
        `https://www.googleapis.com/youtube/v3/videos?part=liveStreamingDetails&id=${YOUTUBE_VIDEO_ID}&key=${API_KEY}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        setApiErrors((prev) => ({ ...prev, youtube: true }));
        throw new Error(`YouTube API error (${response.status}): ${errorText}`);
      }

      setApiErrors((prev) => ({ ...prev, youtube: false }));
      const data = await response.json();

      if (
        data.items &&
        data.items.length > 0 &&
        data.items[0].liveStreamingDetails &&
        data.items[0].liveStreamingDetails.activeLiveChatId
      ) {
        setLiveChatId(data.items[0].liveStreamingDetails.activeLiveChatId);
      }
    } catch (error) {
      console.error("Failed to fetch YouTube live chat ID:", error);
    }
  }, [apiErrors.youtube]);

  const postVisitor = useCallback(async () => {
    try {
      await fetch(`${API_URL}/visitors`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          campaign_type: "tunde_gwr",
        }),
      });
    } catch (error) {
      console.error("Failed to post visitor:", error);
    }
  }, []);

  // Keep the fetchViewers function for just the GET request
  const fetchViewers = useCallback(async () => {
    try {
      const viewerResponse = await fetch(`${API_URL}/visitors`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      if (!viewerResponse.ok) {
        const errorText = await viewerResponse.text();
        setApiErrors((prev) => ({ ...prev, youtube: true }));
        throw new Error(`API error (${viewerResponse.status}): ${errorText}`);
      }
      setApiErrors((prev) => ({ ...prev, youtube: false }));

      const viewerData = await viewerResponse.json();

      if (viewerData.status && viewerData.data) {
        setViewers(viewerData.data || 0);
      }
    } catch (error) {
      console.error("Failed to fetch viewers:", error);
    }
  }, []);

  const fetchYouTubeLiveChat = useCallback(async () => {
    if (!liveChatId) {
      return;
    }

    const currentTime = Date.now();
    if (currentTime - lastCallTimeRef.current < throttleInterval) {
      return;
    }

    try {
      const url = `https://www.googleapis.com/youtube/v3/liveChat/messages?liveChatId=${liveChatId}&part=snippet,authorDetails&maxResults=200${
        nextPageToken ? `&pageToken=${nextPageToken}` : ""
      }&key=${API_KEY}`;

      const response = await fetch(url, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      if (apiErrors.livechat) {
        setApiErrors((prev) => ({ ...prev, livechat: false }));
      }

      const data = await response.json();

      if (data.items && data.items.length > 0) {
        const newMessages = data.items.map((item) => ({
          id: item.id,
          user: item.authorDetails.displayName,
          message: item.snippet.displayMessage,
          profileImageUrl: item.authorDetails.profileImageUrl,
          isVerified: item.authorDetails.isVerified,
        }));

        setMessages((prev) => {
          const messageIds = new Set(prev.map((msg) => msg.id));
          const filteredNewMessages = newMessages.filter(
            (msg) => !messageIds.has(msg.id)
          );

          const pinnedMessage = prev[0];
          const nonPinnedMessages = [...prev.slice(1), ...filteredNewMessages];
          const limitedMessages = nonPinnedMessages.slice(-MAX_MESSAGES);

          return [pinnedMessage, ...limitedMessages];
        });

        if (data.nextPageToken) {
          setNextPageToken(data.nextPageToken);
        }
      }

      lastCallTimeRef.current = currentTime;
    } catch (error) {
      console.error("Failed to fetch YouTube live chat:", error);
    }
  }, [liveChatId, nextPageToken, apiErrors.livechat]);

  useEffect(() => {
    let timeoutId;

    if (apiErrors.livechat) {
      timeoutId = setTimeout(() => {
        setApiErrors((prev) => ({ ...prev, livechat: false }));
      }, 60000);
    }

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [apiErrors.livechat]);

  useEffect(() => {
    if (selectedPlatform === "youtube" && !liveChatId) {
      fetchLiveChatId();
    }
  }, [selectedPlatform, liveChatId, fetchLiveChatId]);

  useEffect(() => {
    if (selectedPlatform === "youtube" && liveChatId) {
      fetchYouTubeLiveChat();

      const interval = setInterval(() => {
        fetchYouTubeLiveChat();
      }, 60000);

      return () => clearInterval(interval);
    }
  }, [selectedPlatform, liveChatId, fetchYouTubeLiveChat]);

  const handleSelectPlatform = (platform) => {
    setSelectedPlatform(platform);
    setShowStreamOptions(false);

    setMessages([
      {
        id: 1,
        user: "@chessinlumsafrica",
        message: "We appreciate all the love, support and donations. Ubuntu 💜",
      },
    ]);

    if (platform === "youtube") {
      setLiveChatId(null);
      fetchLiveChatId();
      lastCallTimeRef.current = 0;
    }
  };

  const handleDonation = () => {
    setShowDonateModal(true);
  };

  const handleBackstory = () => {
    setShowBackstoryModal(true);
  };

  const closeModal = () => {
    setShowDonateModal(false);
    setShowBackstoryModal(false);
  };

  // useEffect(() => {
  //   postVisitor();
  // }, [postVisitor]);

  useEffect(() => {
    fetchViewers();

    // const interval = setInterval(() => {
    //   fetchViewers();
    // }, 120000);

    // return () => clearInterval(interval);
  }, [fetchViewers]);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(
      () => {
        setCopiedText(text);
        setTimeout(() => setCopiedText(""), 2000);
      },
      (err) => {
        console.error("Could not copy text: ", err);
      }
    );
  };

  const toggleMobileChatModal = () => {
    setShowMobileChatModal(!showMobileChatModal);
  };

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth <= 768;
      if (isMobile) {
        setChatVisible(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (window.location.hostname === "cisatundegwr.com") {
      window.location.href =
        "https://www.cisatundegwr.com" +
        window.location.pathname +
        window.location.search;
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Guinness World Record Chess Marathon | Chess In Slums Africa
        </title>
        <meta
          name="description"
          content="Witness Tunde's Guinness World Record attempt for the longest chess marathon at Times Square, NYC."
        />
        {/* Social Media Meta Tags */}
        <meta
          property="og:title"
          content="Guinness World Record Chess Marathon"
        />
        <meta
          property="og:description"
          content="Witness Tunde's Guinness World Record attempt for the longest chess marathon at Times Square, NYC."
        />
        <meta
          property="og:image"
          content="https://chessinslums.org/assets/gwr-thumbnail.jpg"
        />
        <meta property="og:url" content="https://chessinslums.org/tundeGWR" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />

        {/* Google Analytics Script */}
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-B2H1D5ZLD8"
        ></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-B2H1D5ZLD8');
          `}
        </script>
      </Helmet>

      <PageContainer>
        <ContentWrapper>
          <Header>
            <a
              href="https://chessinslumsafrica.com/"
              target="_blank"
              rel="noreferrer"
            >
              <Logo>
                <img src={logo} alt="Chess In Slums Africa Logo" />
              </Logo>
            </a>

            <ViewerCount>
              <div>
                <i className="fas fa-eye"></i>{" "}
                <TimerDisplay>
                  <p>{viewers.toLocaleString()}</p>
                  <sup>views</sup>
                </TimerDisplay>
              </div>

              <TimerDisplay>
                <ClockIcon>
                  <Clock />
                </ClockIcon>
                <p>
                  {/* {String(timer.hours).padStart(2, "0")} */}
                  64
                </p>
                <sup>hr</sup>
                {" : "}
                <p>
                  {/* {String(timer.minutes).padStart(2, "0")} */}
                  02
                </p>
                <sup>min</sup>
                {" : "}
                <p>
                  {/* {String(timer.seconds).padStart(2, "0")} */}
                  00
                </p>
                <sup>sec</sup>
              </TimerDisplay>
            </ViewerCount>
          </Header>

          <MainContent
            style={{
              gridTemplateColumns:
                window.innerWidth <= 1024 ? "1fr" : "250px 1fr 300px",
              marginTop: "2rem",
            }}
          >
            <InfoPanel>
              <InfoCard>
                <Target />

                <div>
                  <InfoTitle>70 Hours</InfoTitle>
                  <InfoSubtitle>Target</InfoSubtitle>
                </div>
              </InfoCard>

              <InfoCard>
                <NewYork />

                <div>
                  <InfoTitle>NYC, Times Sqr</InfoTitle>
                  <InfoSubtitle>Location</InfoSubtitle>
                </div>
              </InfoCard>

              <InfoCard>
                <World />

                <div>
                  <InfoTitle>
                    Nigeria
                    <img src={flag} alt="Nigeria Flag" />
                  </InfoTitle>
                  <InfoSubtitle>Nationality</InfoSubtitle>
                </div>
              </InfoCard>

              <InfoCard>
                <Calendar />

                <div>
                  <InfoSubtitle>
                    Start Date: <span>April 17</span>
                  </InfoSubtitle>
                  <InfoSubtitle>
                    End Date: <span>April 20</span>
                  </InfoSubtitle>
                </div>
              </InfoCard>

              <InfoCard>
                <Money />

                <div>
                  <InfoTitle>$1,000,000</InfoTitle>
                  <InfoSubtitle>Fundraising Goal</InfoSubtitle>
                </div>
              </InfoCard>

              <QuoteBox>
                " The goal is to build the largest tuition-free school for
                vulnerable children "
              </QuoteBox>

              <DonateButton onClick={handleDonation}>
                Donate <i className="fas fa-heart"></i>
              </DonateButton>
            </InfoPanel>

            <StreamPanel
              style={{
                gridColumn: "2",
                position: "relative",
              }}
            >
              <VideoContainer>
                {selectedPlatform === "youtube" ? (
                  <iframe
                    src={`https://www.youtube.com/embed/w_-PzPMdGcg?si=Xddni6cwXMR6eCn5`}
                    // src={`https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}?si=${YOUTUBE_VIDEO_ID}`}
                    frameBorder="0"
                    allowFullScreen
                    title="Chess Marathon Livestream - YouTube"
                  ></iframe>
                ) : (
                  <iframe
                    src="https://player.twitch.tv/?channel=chessinslums&parent=www.cisatundegwr.com"
                    frameBorder="0"
                    allowFullScreen
                    title="Chess Marathon Livestream - Twitch"
                  ></iframe>
                )}

                <StreamToggle
                  onClick={() => setShowStreamOptions(!showStreamOptions)}
                >
                  {selectedPlatform === "youtube" ? (
                    <>
                      <i className="fab fa-youtube"></i> YouTube Live{" "}
                      <i className="fas fa-caret-down"></i>
                    </>
                  ) : (
                    <>
                      <i className="fab fa-twitch"></i> Twitch TV{" "}
                      <i className="fas fa-caret-down"></i>
                    </>
                  )}
                </StreamToggle>

                {showStreamOptions && (
                  <StreamOptions>
                    <StreamOption
                      active={selectedPlatform === "twitch"}
                      onClick={() => handleSelectPlatform("twitch")}
                    >
                      <i className="fab fa-twitch"></i> Stream 1: Twitch TV
                    </StreamOption>

                    <StreamOption
                      active={selectedPlatform === "youtube"}
                      onClick={() => handleSelectPlatform("youtube")}
                    >
                      <i className="fab fa-youtube"></i> Stream 2: YouTube Live
                    </StreamOption>
                  </StreamOptions>
                )}
              </VideoContainer>

              <RecordTitle>
                GUINNESS WORLD RECORD ATTEMPT FOR LONGEST CHESS MARATHON...
                <ReadMore onClick={handleBackstory}>Read Backstory</ReadMore>
              </RecordTitle>

              <ParticipantsSection>
                <ParticipantContainer>
                  {PARTICIPANTS.map((participant) => (
                    <ParticipantWrapper
                      key={participant.id}
                      style={{
                        filter:
                          hoveredParticipant &&
                          hoveredParticipant !== participant.id
                            ? "blur(2px)"
                            : "none",
                        opacity:
                          hoveredParticipant &&
                          hoveredParticipant !== participant.id
                            ? 0.6
                            : 1,
                      }}
                    >
                      <ParticipantLink
                        href={participant.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Participant
                          src={participant.image}
                          alt={participant.name}
                          onMouseEnter={() =>
                            setHoveredParticipant(participant.id)
                          }
                          onMouseLeave={() => setHoveredParticipant(null)}
                        />
                        <InstagramBadge
                          style={{
                            opacity:
                              hoveredParticipant === participant.id ? 1 : 0,
                          }}
                        >
                          <InstagramIcon>
                            <i className="fab fa-instagram"></i>
                          </InstagramIcon>
                          {participant.instagram}
                        </InstagramBadge>
                      </ParticipantLink>
                    </ParticipantWrapper>
                  ))}
                </ParticipantContainer>
              </ParticipantsSection>
            </StreamPanel>

            <ChatPanel visible={chatVisible}>
              <ChatTitle>
                <ChatIcon />
                Live Chat
                <HideChatButton
                  onClick={() => {
                    if (window.innerWidth <= 768) {
                      toggleMobileChatModal();
                    } else {
                      setChatVisible(!chatVisible);
                    }
                  }}
                >
                  {chatVisible ? "HIDE CHAT" : "SHOW CHAT"}
                </HideChatButton>
              </ChatTitle>

              {selectedPlatform === "youtube" ? (
                <>
                  <ChatMessages>
                    <PinnedMessage>
                      <UserAvatar src={cislogo} alt={messages[0].user} />
                      <MessageContent>
                        <ChatUser>
                          @{messages[0].user.replace("@", "")}
                        </ChatUser>
                        <ChatText>{messages[0].message}</ChatText>
                      </MessageContent>
                      <PinnedIcon>
                        <i className="fas fa-thumbtack"></i>
                      </PinnedIcon>
                    </PinnedMessage>

                    <VisibleChat visible={chatVisible}>
                      {messages.slice(1).map((msg, index) => (
                        <RegularMessage key={msg.id}>
                          <RegularUser>
                            @{msg.user.replace("@", "")}
                          </RegularUser>
                          <RegularText>{msg.message}</RegularText>
                        </RegularMessage>
                      ))}
                    </VisibleChat>
                  </ChatMessages>
                </>
              ) : (
                <>
                  <ChatMessages>
                    <PinnedMessage>
                      <UserAvatar src={cislogo} alt={messages[0].user} />
                      <MessageContent>
                        <ChatUser>
                          @{messages[0].user.replace("@", "")}
                        </ChatUser>
                        <ChatText>{messages[0].message}</ChatText>
                      </MessageContent>
                      <PinnedIcon>
                        <i className="fas fa-thumbtack"></i>
                      </PinnedIcon>
                    </PinnedMessage>

                    <VisibleChat visible={chatVisible}>
                      <iframe
                        src="https://www.twitch.tv/embed/chessinslums/chat?parent=www.cisatundegwr.com"
                        frameBorder="0"
                        allowFullScreen
                        title="Chess Marathon Livestream - Twitch"
                        height="100%"
                      ></iframe>
                    </VisibleChat>
                  </ChatMessages>
                </>
              )}
            </ChatPanel>
          </MainContent>
        </ContentWrapper>
      </PageContainer>

      {/*  mobile donate button */}
      <MobileDonateButton onClick={handleDonation}>
        <DonateButton onClick={handleDonation}>
          Donate <i className="fas fa-heart"></i>
        </DonateButton>
      </MobileDonateButton>

      {showDonateModal && (
        <Modal onClick={closeModal}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <h2>Let's Make History Together</h2>
              <CloseButton onClick={closeModal}>&times;</CloseButton>
            </ModalHeader>
            <ModalBody>
              {DONATION_OPTIONS.map((option) => (
                <DonationOption
                  key={option.id}
                  href={option.link || undefined}
                  target={option.link ? "_blank" : undefined}
                  rel={option.link ? "noopener noreferrer" : undefined}
                  as={!option.link ? "div" : "a"}
                  onClick={() => {
                    if (option.isCrypto) {
                      setShowCryptoModal(true);
                      setShowDonateModal(false);
                    }
                  }}
                >
                  <DonationIcon>
                    <i className={`fas ${option.icon}`}></i>
                  </DonationIcon>
                  <DonationInfo>
                    <DonationTitle>{option.title}</DonationTitle>
                    <DonationDescription>
                      {option.description}
                      {!option.link && !option.isCrypto && (
                        <>
                          <CopyIcon
                            onClick={() => copyToClipboard(option.description)}
                          >
                            <i className="fas fa-copy"></i>
                          </CopyIcon>
                          {copiedText === option.description && (
                            <CopyFeedback>Copied!</CopyFeedback>
                          )}
                        </>
                      )}
                    </DonationDescription>
                  </DonationInfo>
                  {(option.link || option.isCrypto) && (
                    <ArrowIcon>
                      <i className="fas fa-arrow-right"></i>
                    </ArrowIcon>
                  )}
                </DonationOption>
              ))}
            </ModalBody>
          </ModalContent>
        </Modal>
      )}

      {showBackstoryModal && (
        <Modal onClick={closeModal}>
          <BackstoryModalContent onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <div>
                <h2>70 Hours. One Board. A Million Dreams.</h2>
                <p>
                  #70HoursofChessWithTunde #Chessforeducation
                  #ChessMarathonForChange #GWR2025
                </p>
              </div>

              <CloseButton onClick={closeModal}>&times;</CloseButton>
            </ModalHeader>
            <BackstoryModalBody>
              <BackstoryContent>
                {BACKSTORY.split("\n\n").map((paragraph, index) => {
                  if (paragraph.startsWith("## ")) {
                    return (
                      <BackstoryH2 key={index}>
                        {paragraph.substring(3)}
                      </BackstoryH2>
                    );
                  } else if (paragraph.startsWith("### ")) {
                    return (
                      <BackstoryH3 key={index}>
                        {paragraph.substring(4)}
                      </BackstoryH3>
                    );
                  } else if (paragraph.startsWith("- ")) {
                    return (
                      <BackstoryList key={index}>
                        {paragraph.split("\n").map((item, i) => (
                          <BackstoryListItem key={i}>
                            {item.substring(2)}
                          </BackstoryListItem>
                        ))}
                      </BackstoryList>
                    );
                  } else {
                    return (
                      <BackstoryParagraph key={index}>
                        {paragraph}
                      </BackstoryParagraph>
                    );
                  }
                })}
              </BackstoryContent>
              <BackstoryCTA>
                <DonateButton
                  onClick={() => {
                    closeModal();
                    setTimeout(() => setShowDonateModal(true), 300);
                  }}
                >
                  Support This Cause <i className="fas fa-heart"></i>
                </DonateButton>
              </BackstoryCTA>
            </BackstoryModalBody>
          </BackstoryModalContent>
        </Modal>
      )}

      {showMobileChatModal && (
        <MobileChatModal>
          <MobileChatContainer>
            <MobileChatHeader>
              <span>Live Chat</span>
              <CloseModalButton onClick={toggleMobileChatModal}>
                &times;
              </CloseModalButton>
            </MobileChatHeader>
            <MobileChatContent>
              {selectedPlatform === "youtube" ? (
                <>
                  <PinnedMessage>
                    <UserAvatar src={cislogo} alt={messages[0].user} />
                    <MessageContent>
                      <ChatUser>@{messages[0].user.replace("@", "")}</ChatUser>
                      <ChatText>{messages[0].message}</ChatText>
                    </MessageContent>
                    <PinnedIcon>
                      <i className="fas fa-thumbtack"></i>
                    </PinnedIcon>
                  </PinnedMessage>
                  <MobileScrollableMessages>
                    {messages.slice(1).map((msg, index) => (
                      <RegularMessage key={msg.id}>
                        <RegularUser>@{msg.user.replace("@", "")}</RegularUser>
                        <RegularText>{msg.message}</RegularText>
                      </RegularMessage>
                    ))}
                  </MobileScrollableMessages>
                </>
              ) : (
                <>
                  <PinnedMessage>
                    <UserAvatar src={cislogo} alt={messages[0].user} />
                    <MessageContent>
                      <ChatUser>@{messages[0].user.replace("@", "")}</ChatUser>
                      <ChatText>{messages[0].message}</ChatText>
                    </MessageContent>
                    <PinnedIcon>
                      <i className="fas fa-thumbtack"></i>
                    </PinnedIcon>
                  </PinnedMessage>
                  <div style={{ flex: 1, overflow: "hidden", display: "flex" }}>
                    <iframe
                      src="https://www.twitch.tv/embed/chessinslums/chat?parent=www.cisatundegwr.com"
                      frameBorder="0"
                      allowFullScreen
                      title="Chess Marathon Livestream - Twitch"
                      style={{ flex: 1, width: "100%", height: "100%" }}
                    ></iframe>
                  </div>
                </>
              )}
            </MobileChatContent>
          </MobileChatContainer>
        </MobileChatModal>
      )}

      {showCryptoModal && (
        <Modal onClick={() => setShowCryptoModal(false)}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <h2>Crypto Donation Wallets</h2>
              <CloseButton onClick={() => setShowCryptoModal(false)}>
                &times;
              </CloseButton>
            </ModalHeader>
            <ModalBody>
              {CRYPTO_WALLETS.map((wallet) => (
                <CryptoWallet key={wallet.name}>
                  <CryptoName>{wallet.name}</CryptoName>
                  <CryptoAddress>
                    {wallet.address}
                    <CopyIcon onClick={() => copyToClipboard(wallet.address)}>
                      <i className="fas fa-copy"></i>
                    </CopyIcon>
                    {copiedText === wallet.address && (
                      <CopyFeedback>Copied!</CopyFeedback>
                    )}
                  </CryptoAddress>
                </CryptoWallet>
              ))}
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};

// Styled Components
const PageContainer = styled.div`
  min-height: 100vh;
  padding: 2rem;
  display: flex;
  justify-content: center;
  font-family: "Raleway", sans-serif;
  overflow: hidden;
  background: white;

  @media (max-width: 768px) {
    padding: 1rem;
    padding-bottom: 5rem; /* Add space for the fixed donate button */
  }
`;

const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1rem;
  border-bottom: 1px solid #eee;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
  }
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  img {
    height: 48px;
  }
`;

const ViewerCount = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  font-weight: 500;

  i {
    margin-right: 5px;
  }

  div {
    font-family: "Raleway", sans-serif;
    display: flex;
    align-items: center;
    gap: 5px;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const TimerDisplay = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-family: "Raleway", sans-serif;

  p {
    margin: 0;
    font-size: 18px;
    padding: 0;
    font-weight: 500;

    @media (max-width: 768px) {
      font-size: 16px;
    }
  }

  sup {
    font-size: 12px;
    margin-left: 2px;
    margin-bottom: 5px;
    font-family: "Raleway", sans-serif;
    color: #8e8e8e;
    font-weight: 600;
  }
`;

const ClockIcon = styled.span`
  margin-right: 0px;
`;

const MainContent = styled.main`
  display: grid;
  grid-template-columns: 250px 1fr 300px;
  grid-template-rows: auto;
  gap: 2rem;
  margin-top: 2rem;

  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column-reverse;
    gap: 2rem;
  }
`;

const InfoPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  height: 100%;
  border-radius: 10px;
  border: 1px solid #e6e6e6;
  padding: 10px;

  button {
    display: flex;
    @media (max-width: 768px) {
      display: none;
    }
  }
`;

const InfoCard = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const InfoTitle = styled.h3`
  font-size: 22px;
  margin: 0;
  font-weight: 700;
  font-family: "Raleway", sans-serif;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  img {
    width: 20px;
    height: 20px;
  }
`;

const InfoSubtitle = styled.p`
  margin: 0;
  margin-top: 3px;
  font-size: 16px;
  color: #5a5a5a;
  font-weight: 300;
  font-family: "Raleway", sans-serif;

  span {
    font-weight: 700;
  }
`;

const QuoteBox = styled.div`
  color: #5a5a5a;
  padding-left: 1rem;
  margin: 1rem 0;
  font-family: "Raleway", sans-serif;
  font-size: 14px;
  font-weight: 600;
`;

const DonateButton = styled.button`
  background: #b8860b;
  color: white;
  border: none;
  border-radius: 30px;
  padding: 0.8rem 2rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 1rem;

  &:hover {
    background: #9a7209;
  }
`;

const StreamPanel = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background: #000;
  border-radius: 10px;
  overflow: hidden;

  iframe {
    width: 100%;
    height: 100%;
    min-height: 62vh;

    @media (max-width: 768px) {
      min-height: 300px;
    }
  }
`;

const StreamToggle = styled.div`
  position: absolute;
  top: 1rem;
  left: 1rem;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  z-index: 10;

  &:hover {
    background: rgba(0, 0, 0, 0.8);
  }

  .fa-caret-down {
    margin-left: 0.5rem;
  }
`;

const StreamOptions = styled.div`
  position: absolute;
  top: 3rem;
  left: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  padding: 0.5rem;
  z-index: 10;

  @media (max-width: 768px) {
    width: 80%;
  }
`;

const StreamOption = styled.div`
  background: ${(props) => (props.active ? "#ff0000" : "transparent")};
  color: white;
  padding: 0.3rem 0.8rem;
  border-radius: 4px;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: ${(props) =>
      props.active ? "#ff0000" : "rgba(255, 0, 0, 0.5)"};
  }

  i {
    font-size: 1rem;
  }
`;

const RecordTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 800;
  margin: 0.5rem 0;
`;

const ReadMore = styled.span`
  color: #3b82f6;
  font-size: 1rem;
  font-weight: normal;
  margin-left: 0.5rem;
  cursor: pointer;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const ParticipantsSection = styled.div`
  margin-top: 10px;
`;

const ParticipantContainer = styled.div`
  display: flex;
  position: relative;
  width: fit-content;

  /* Add negative margin to create overlap */
  & > *:nth-child(2) {
    margin-left: -30px; /* Creates overlap effect */
  }
`;

const ParticipantWrapper = styled.div`
  position: relative;
  transition: all 0.4s ease;
  z-index: 1;
  width: fit-content;

  &:hover {
    z-index: 5;
  }
`;

const Participant = styled.img`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  object-fit: cover;
  transition: all 0.3s ease;
  cursor: pointer;
`;

const ParticipantLink = styled.a`
  text-decoration: none;
  color: inherit;
  display: block;
  position: relative;
  width: fit-content;
`;

const InstagramBadge = styled.div`
  position: absolute;
  bottom: -30px;
  left: 50%;
  transform: translateX(-50%);
  background: #ffebf6;
  color: #c13584;
  padding: 8px 15px;
  border-radius: 30px;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
  opacity: 0;
  white-space: nowrap;
  transition: opacity 0.3s ease, transform 0.3s ease;
  z-index: 10;

  ${ParticipantWrapper}:hover & {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }

  ${ParticipantWrapper}:nth-child(2) & {
    background: #ebf5ff;
    color: #1877f2;
  }
`;

const InstagramIcon = styled.span`
  font-size: 1.2rem;
  color: #c13584;

  ${ParticipantWrapper}:nth-child(2) & {
    color: #1877f2;
  }
`;

const ChatPanel = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  overflow: hidden;
  background: white;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  height: ${(props) => (props.visible ? "82vh" : "fit-content")};
  width: 100%;
  transition: height 0.3s ease;
  grid-column: 3;

  @media (max-width: 1024px) {
    grid-column: 1;
    margin-top: 1rem;
  }

  @media (max-width: 768px) {
    margin-top: ${(props) => (props.visible ? "1rem" : "0")};
  }
`;

const VisibleChat = styled.div`
  display: ${(props) => (props.visible ? "flex" : "none")};
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
`;

const ChatTitle = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  font-weight: 600;
  font-size: 15px;
  gap: 10px;
  font-family: "Euclid Circular A", sans-serif;

  i {
    margin-right: 7px;
  }
`;

const HideChatButton = styled.span`
  margin-left: auto;
  color: #939393;
  font-size: 10px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
const ChatMessages = styled.div`
  flex: 1;
  padding: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  background: white;
  // max-height: calc(72vh - 110px);

  /* Scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #ddd;
    border-radius: 3px;
  }
`;

const PinnedMessage = styled.div`
  padding: 12px 16px;
  width: 100%;
  background: #121212;
  color: white;
  display: flex;
  align-items: flex-start;
`;

const RegularMessage = styled.div`
  padding: 8px 16px;
  width: 100%;
  background: white;
  color: #333;
  border-bottom: 1px solid #f0f0f0;
`;

const PinnedIcon = styled.span`
  margin-left: auto;
  color: #fff;
  cursor: pointer;

  i {
    transform: rotate(45deg);
    font-size: 10px;
  }
`;

const RegularUser = styled.div`
  font-weight: 500;
  font-size: 0.8rem;
  color: #555;
  margin-bottom: 2px;
`;

const RegularText = styled.div`
  font-size: 0.85rem;
  color: #333;
  line-height: 1.3;
`;

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 10px;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid #eee;

  h2 {
    margin: 0;
    font-size: 1.5rem;
    color: #333;
  }

  div {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  color: #999;

  &:hover {
    color: #333;
  }
`;

const ModalBody = styled.div`
  padding: 1.5rem;
`;

const DonationOption = styled.a`
  display: flex;
  align-items: center;
  padding: 1rem;
  margin-bottom: 1rem;
  border-radius: 10px;
  background: #f8f8f8;
  text-decoration: none;
  color: inherit;
  transition: all 0.3s ease;

  &:hover {
    background: #f0f0f0;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

const DonationIcon = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #b8860b;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  margin-right: 1rem;
`;

const DonationInfo = styled.div`
  flex: 1;
`;

const DonationTitle = styled.h3`
  margin: 0 0 0.5rem 0;
  font-size: 1.2rem;
`;

const DonationDescription = styled.p`
  margin: 0;
  font-size: 0.9rem;
  color: #666;
  white-space: pre-line;
  font-family: "Raleway", sans-serif;
  line-height: 1.5;
  position: relative;
`;

const CopyIcon = styled.span`
  position: absolute;
  right: -5px;
  top: 0;
  cursor: pointer;
  color: #b8860b;
  font-size: 1rem;
  opacity: 0.7;
  transition: opacity 0.2s;

  &:hover {
    opacity: 1;
  }
`;

const CopyFeedback = styled.span`
  position: absolute;
  right: -50px;
  top: 0;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.7rem;
  animation: fadeIn 0.3s;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const ArrowIcon = styled.div`
  color: #b8860b;
  font-size: 1.2rem;
`;

const BackstoryModalContent = styled(ModalContent)`
  max-width: 700px;
`;

const BackstoryModalBody = styled(ModalBody)`
  padding: 2rem;
`;

const BackstoryContent = styled.div`
  font-family: "Raleway", sans-serif;
  color: #333;
  line-height: 1.6;
`;

const BackstoryH2 = styled.h2`
  font-size: 1.8rem;
  margin: 0 0 1.5rem 0;
  color: #111;
  border-bottom: 2px solid #b8860b;
  padding-bottom: 0.5rem;
`;

const BackstoryH3 = styled.h3`
  font-size: 1.3rem;
  margin: 1.5rem 0 1rem 0;
  color: #333;
`;

const BackstoryParagraph = styled.p`
  margin: 0 0 1rem 0;
  font-size: 1rem;
`;

const BackstoryList = styled.ul`
  margin: 0 0 1rem 0;
  padding-left: 1.5rem;
`;

const BackstoryListItem = styled.li`
  margin-bottom: 0.5rem;
`;

const BackstoryCTA = styled.div`
  margin-top: 2rem;
  display: flex;
  justify-content: center;

  ${DonateButton} {
    padding: 0.8rem 2rem;
  }
`;

const UserAvatar = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-right: 12px;
  object-fit: cover;
`;

const MessageContent = styled.div`
  flex: 1;
`;

const ChatUser = styled.div`
  font-weight: 500;
  margin-bottom: 4px;
  color: #fff;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: "Raleway", sans-serif;
`;

const ChatText = styled.div`
  font-size: 14px;
  color: #fff;
  line-height: 1.4;
  font-family: "Raleway", sans-serif;
`;

// Add a MobileDonateButton component
const MobileDonateButton = styled.div`
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  border: none;
  font-weight: bold;
  text-align: center;
  font-size: 1.1rem;
  cursor: pointer;
  z-index: 100;
  background: linear-gradient(
    198.25deg,
    #ffffff -87.79%,
    rgba(186, 140, 0, 0.5) 241.19%
  );
  backdrop-filter: blur(25px);

  button {
    width: 100%;
    margin: 1rem 3rem;
  }

  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
  }
`;

// Mobile Chat Modal Components
const MobileChatModal = styled.div`
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 2000;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  @media (max-width: 768px) {
    display: flex;
  }
`;

const MobileChatContainer = styled.div`
  background: white;
  width: 92%;
  height: 80%;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
`;

const MobileChatHeader = styled.div`
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  font-weight: 600;
  font-size: 18px;
`;

const CloseModalButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;

  &:hover {
    color: #333;
  }
`;

const MobileChatContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

// Add a new component for scrollable messages below the pinned message
const MobileScrollableMessages = styled.div`
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  /* Scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #ddd;
    border-radius: 3px;
  }
`;

const CryptoWallet = styled.div`
  margin-bottom: 1.5rem;
  background: #f8f8f8;
  padding: 1rem;
  border-radius: 8px;
`;

const CryptoName = styled.div`
  font-weight: 600;
  font-size: 1rem;
  margin-bottom: 0.5rem;
  color: #333;
`;

const CryptoAddress = styled.div`
  font-family: monospace;
  font-size: 0.9rem;
  color: #666;
  background: #fff;
  padding: 0.5rem;
  border-radius: 4px;
  border: 1px solid #eee;
  overflow-wrap: break-word;
  position: relative;
  padding-right: 2rem;
`;

export default TundeGWR;
